import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MapPin, Calendar, ChevronRight } from "lucide-react";
import { Badge } from "@tabipla/ui";
import { getStatusBadgeStyle } from "@/utils/trip-detail";

interface TripCardProps {
  trip: {
    id: string;
    title: string;
    destination: string;
    startDate: string | null;
    status: string;
  };
}

export function TripCard({ trip }: TripCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      className="flex cursor-pointer items-center justify-between rounded-xl border p-4 transition-all hover:-translate-y-0.5 hover:shadow-md active:scale-[0.99]"
      onClick={() => navigate(`/trips/${trip.id}`)}
    >
      <div className="min-w-0 flex-1">
        <h3 className="truncate font-semibold">{trip.title}</h3>
        <div className="mt-1 flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
          <span className="flex items-center gap-1">
            <MapPin className="h-3.5 w-3.5" />
            {trip.destination}
          </span>
          <span className="flex items-center gap-1">
            <Calendar className="h-3.5 w-3.5" />
            {trip.startDate
              ? new Date(trip.startDate).toLocaleDateString("ja-JP")
              : t("trips.dateUndecided", "日程未定")}
          </span>
        </div>
      </div>
      <div className="ml-4 flex items-center gap-3">
        <Badge className={getStatusBadgeStyle(trip.status)}>
          {t(`trips.status${trip.status.charAt(0).toUpperCase() + trip.status.slice(1)}`)}
        </Badge>
        <ChevronRight className="h-4 w-4 text-muted-foreground" />
      </div>
    </div>
  );
}
